export default __webpack_public_path__ + "static/media/referral-claim.b042db0f.png";